module.exports = __webpack_public_path__ + "img/sprinkle-16.612b1d7f.webp";